import MuiAvatar from '@mui/material/Avatar';
import { themeColors } from '../theme/theme';

export function Avatar({ src, alt, size = 48, ...props }) {
  return (
    <MuiAvatar
      src={src}
      alt={alt || 'User Avatar'}
      sx={{ width: size, height: size, fontFamily: themeColors.fontFamily }}
      {...props}
    />
  );
}
